import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import React, { useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { TabStyled } from '../styled/HeaderLinkStyled'
import { HeaderItem } from '../types'
import { samePageLinkNavigation } from './utils'

interface LinkTabProps {
  label?: string
  href?: string
  selected?: boolean
  to?: string
  children?: HeaderItem['children']
}

export const LinkTab: React.FC<LinkTabProps> = (props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { children, ...linkProps } = props
  const [open, setOpen] = useState(false)
  const tabRef = useRef<HTMLDivElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setOpen(true)
    if (!linkProps.to) {
      return
    }
    if (samePageLinkNavigation(event)) {
      event.preventDefault()
      void navigate(linkProps.to)
    }
  }

  const handleChildClick = (path: string) => {
    void navigate(path)
    setOpen(false)
  }

  // Clean up linkProps to avoid passing empty href
  const cleanedLinkProps = {
    ...linkProps,
    // Pass null instead of empty string for href to avoid React warnings
    href: linkProps.href || null,
  }

  return (
    <>
      <TabStyled
        onClick={handleClick}
        aria-current={linkProps.selected && 'page'}
        {...cleanedLinkProps}
        id={linkProps.label}
        ref={tabRef}
        sx={{ minWidth: '125px' }}
      />
      {children && (
        <Menu open={open} onClose={() => setOpen(false)} anchorEl={tabRef.current}>
          {children.map((child, index) => (
            <MenuItem
              key={index}
              selected={location.pathname.includes(child.path)}
              onClick={() => handleChildClick(child.path)}
              sx={{ width: tabRef.current?.clientWidth }}
            >
              {child.name}
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  )
}
